module.exports = __webpack_public_path__ + "img/arrow-2.f6358173.svg";